import React, { useEffect, useState } from 'react';
import { configApi } from '../services/api';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

// Bank Name picker.
//
// This field used to be free text on payments and on bank reconciliation, and ten
// spellings of one bank built up — DFCU KISAASI, DFCU - KISAASI, DFCU Kisaasi,
// dfcu, "DFCU ", DFC, DCFU, DFCU KISAAAI — which made reporting by bank account
// impossible. The options come from /api/config (config.BANKS, extendable by an
// admin via /api/config/banks), so adding an account never means retyping one.
//
// The branch is deliberately not part of a bank's name: a bank transaction carries
// its own branch field.
//
// A value already on a record that is no longer on the list (a historic spelling,
// or a bank since retired) is shown as an extra option rather than silently
// cleared — editing an old record must not rewrite a field nobody touched.

let cachedBanks = null;          // module-level so N pickers share one request

export function BankSelect({ value, onChange, placeholder = 'Select bank', testId, disabled }) {
  const [banks, setBanks] = useState(cachedBanks || []);

  useEffect(() => {
    if (cachedBanks) return;
    configApi.get()
      .then((r) => {
        cachedBanks = r.data?.banks || [];
        setBanks(cachedBanks);
      })
      .catch(() => {});
  }, []);

  const options = value && !banks.includes(value) ? [...banks, value] : banks;

  return (
    <Select value={value || undefined} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {options.map((b) => (
          <SelectItem key={b} value={b}>{b}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default BankSelect;
